import React from 'react';
const RegistroDonacion = props => {
  return (
    <section className="bg-gradient-to-b from-[#EFF5F4] to-white py-10 m-0 w-full">
      <div className="px-4 md:container md:mx-auto">
        <div className="grid grid-cols-12 gap-4 items-center">
          <div className="col-span-12 md:col-span-12 md:pr-10">
            <div className="w-full max-w-full overflow-hidden">
              <iframe
                title="Formulario de contacto – Reserva de clases"
                src="https://docs.google.com/forms/d/e/1FAIpQLScJ2UO3qUz8mZgfhzbnMrjO76ePAYBC_gBVjG7ZEfC_gi7dig/viewform?embedded=true"
                className="w-full h-[2000px] sm:h-[3000px] md:h-[4000px] lg:h-[5000px]"
                allowFullScreen
              >
                Cargando…
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegistroDonacion;
